import React from 'react'

const Table = () => {
  const headerMap = ["", "Ikea place", "Houzz", "Wayfair"];
  const data = [
    {
      title: "Features",
      bg: "#705217",
      color: "white",
      rowBg: "#907237",
      list1: [
        "3D images are quite accurate and can convey real-life sizes",
        "Ability to browse the products through category or browse-all proucts",
      ],
      list2: [
        "In-app purchase.",
        "Shop by looking at inspiration photo-tags on products to see details.",
      ],
      list3: [
        "View in Room 3D feature allows users to view virtual objects in their space",
        "In-app purchase.",
      ],
    },
    {
      title: "Strength",
      bg: "#ffe4b0",
      color: "#46320d",
      rowBg: "#ffffed",
      list1: [
        "Aesthetic and minimal design",
        "Limited functionality makes it easier to use.",
        "The app’s catalogue of over 2,000 products.",
      ],
      list2: [
        "3D label to view products in AR view",
        "Ability to add multiple items in AR view",
      ],
      list3: [
        "Dimensions of the product appear when the product is selected in AR mode",
        "Variety of options to choose from",
      ],
    },
    {
      title: "Weaknesses",
      bg: "#e0e0e0",
      color: "#46320d",
      rowBg: "#fff",
      list1: [
        "App limited to Ikeas products",
        "No option to purchase within app.",
      ],
      list2: [
        "Not all the products are available to view in AR",
        "App limited to only furniture",
      ],
      list3: [
        "Not all the products are available to view in AR",
        "App limited to only furniture",
      ],
    },
  ];

  return (
    <table>
      <thead>
        <tr>
          {headerMap.map((item, i) => (
            <th key={i}>{item}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, id) => (
          <tr key={id} style={{ background: item.rowBg, color: item.color }}>
            <td style={{ background: item.bg }}>
              <p>{item.title}</p>
            </td>
            <td>
              {item.list1.map((item2, i) => (
                <li key={i}>
                  <ul>{item2}</ul>
                </li>
              ))}
            </td>
            <td>
              {item.list2.map((item2, i) => (
                <li key={i}>
                  <ul>{item2}</ul>
                </li>
              ))}
            </td>{" "}
            <td>
              {item.list3.map((item2, i) => (
                <li key={i}>
                  <ul>{item2}</ul>
                </li>
              ))}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table